import returnStateName from '../general/returnStateName';
import returnPinCoordinateForState from './returnPinCoordinateForState';

/**
 * Updates our map with state fill color & location pin
 * @param {String} customStateCode - State code of user's location
 * @param {String} fillColor - Fill color for the active state
 */

export default function updateMapWithGeoData(customStateCode = null, fillColor = '#367BB4') {
	const geolocationState = window.geolocation?.currentLocation?.state,
		state = customStateCode != null ? returnStateName(customStateCode) : geolocationState,
		statecode = customStateCode != null ? customStateCode : window.geolocation?.currentLocation?.statecode;

	if (state) {
		const formattedState = state.toLowerCase().split(' ').join('-');
		const stateSvgEle = document.querySelector(`.svg-map #${formattedState} path`);
		if (window.prevColouredState) {
			document.querySelector(`.svg-map #${window.prevColouredState} path`).style.fill = '#F9F9F9';
		}
		if (stateSvgEle) {
			stateSvgEle.style.fill = fillColor;
			const pinElement = document.querySelector('.svg-map #pin');
			pinElement.style.opacity = 1;
			pinElement.setAttribute('x', returnPinCoordinateForState(statecode).x);
			pinElement.setAttribute('y', returnPinCoordinateForState(statecode).y);
			window.prevColouredState = formattedState;
		} else {
			window.prevColouredState = null;
		}
	}
}